import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './ColoringPage.css';
import { fetchInitialData } from "../fetchData";
import ShareOptions from './common/ShareOptions';
import Service from '../service/Service';
import * as action from './Actions';
import withLocation from "../../withLocation";
import { AdSlot, DFPSlotsProvider } from 'react-dfp'
import withContext from "../../withContext";
// import { Bling as GPT } from "react-gpt";
const service = new Service();

const gptAry = {

    "desktop": {
        path: "/84382175/parenting.com/Parenting.com_ColoringPages_Desktop_DownloadBtn_336x280",
        slot: [[310, 100], [320, 50], [300, 250]],
        id: "div-gpt-ad-1671527797228-0",
    },
    "msite": {
        path: "/84382175/parenting.com/Parenting.com_ColoringPages_Msite_DownloadBtn_336x280",
        slot: [[310, 100], [320, 50], [300, 250]],
        id: "div-gpt-ad-1671527844495-0",
    },
    "desktoplhs": {
        path: "/84382175/parenting.com/Parenting.com_ColoringPages_Desktop_LHS_160x600",
        // slot: [[310, 100], [320, 50], [300, 250]],
        slot:[160,600],
        id: "div-gpt-ad-1671527807831-0",
    },
    "desktoprhs": {
        path: "/84382175/parenting.com/Parenting.com_ColoringPages_Desktop_RHS_160x600",
        // slot: [[310, 100], [320, 50], [300, 250]],
        slot:[160,600],
        id: "div-gpt-ad-1671527832715-0",
    },
}

class ColoringDetails extends Component {
    constructor(props) {
        super(props);
        console.log("ColoringDetails Page Loaded !!")
        // this.SubOfSubCatName = this.props.params.SubOfSubCatName;
        // this.subCatId = this.props.params.subCatId;
        let initialData = [];
        let serverSideData = {};
        var seoData = [];
        var CatNameBreadcrm = '';

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        console.log("serverSideData 111 --- ", serverSideData);
        if (serverSideData && serverSideData['msg'] == 1) {
            initialData = {
             subCategory: serverSideData['subCategory'],
             otherCategories: serverSideData['otherCategories'],
             seoData: serverSideData['seoData'],
            }
        }
        console.log("initialData =::: ",initialData)
        var urlParam = (props.location.pathname + props.location.search);
        console.log("urlParam======>", urlParam);
        if (urlParam.split("/")[3]) {
            CatNameBreadcrm = urlParam && urlParam.split("/")[3].split("-").slice(0,-1).join(" ");
            // CatNameBreadcrm = hostUrl[0].replace(/-/g, " ");
            CatNameBreadcrm = CatNameBreadcrm && CatNameBreadcrm.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
        }
        console.log("CatNameBreadcrm======>", CatNameBreadcrm);
        this.state = {
            page: (initialData.seoData[0] && initialData.seoData!="") ? initialData.seoData[0].pageTitle:'',
            metaTitle: (initialData.seoData[0] && initialData.seoData!="") ? initialData.seoData[0].pageTitle:'',
            metaDescription: [{ "name": "description", "content": (initialData.seoData && initialData.seoData!="")?initialData.seoData[0].metaDescription:'' }, { "name": "keywords", "content": initialData.seoData[0].metaKeywords }],
            seoData:initialData.seoData,
            initialData: initialData,
            CatNameBreadcrm : CatNameBreadcrm,
            isApp: false
        };
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        console.log(reqUrl); 
        var cUrl = reqUrl;
        if (cUrl.includes('?')) {
            cUrl = cUrl.split('?')[0];
        }
        if (cUrl.includes('#')) {
            cUrl = cUrl.split('#')[0];
        }
        var SubOfSubCatName = cUrl.split('/')[3];
        console.log("cUrl===============>",cUrl);
        // console.log("cUrl===============>",cUrl.split('/')[3]);
        // console.log("SubOfSubCatName url===============>",SubOfSubCatName[SubOfSubCatName.length-1]);
        console.log("SubOfSubCatName=========:======>",SubOfSubCatName);
        SubOfSubCatName = SubOfSubCatName.includes("-")
        ? SubOfSubCatName.split("-").slice(0, -1).join(" ")
        : SubOfSubCatName;
        console.log("SubOfSubCatName====*===========>",SubOfSubCatName);

            // var SubOfSubCatName1 = 'alligator crawling coloring page';  
      
        


        var url = global.api_url + "colouringpages/getsubcategorydetails";
        let body = JSON.stringify({
            "subcategoryName": SubOfSubCatName,
            "pageno": 1,
            "pagesize": 10
        });
        console.log("body>>>>>>>>>>>>", body)
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        this.setState({ windowWidth: window.outerWidth });
        document.addEventListener("click", action.domClick);
        // console.log("windowWidth--", window.outerWidth);
        // debugger;
        if(document.getElementsByClassName("otherimg-slide").length > 0){
            this.calculateSliderWidth();
        }
        if (this.props.location.search.includes('from=app')) {
            this.setState({ isApp: true });
        }
    }

    calculateSliderWidth(){
        // debugger;
        let slidemargin = 20;
        if (window.innerWidth < 767)
            slidemargin = 15;
            
        let slides = document.getElementsByClassName("otherimg-slide");
        let slidewd = slides[0].offsetWidth;
        let sliderwidth = (slides.length * (slidewd + slidemargin)) - slidemargin;
        document.querySelector(".other-slider").style.width = sliderwidth + 'px';
        let abc = document.querySelector(".data-container").offsetWidth;
        if(sliderwidth < abc){
            document.querySelector(".img-slider-btm .prv-img").style.display = "none";
            document.querySelector(".img-slider-btm .nxt-img").style.display = "none";
        }
    }
    goBack(){
        window.history.back();
    }

    render() {
        return (
            <div>
                   {/* code for rhs and lhs side ads */}
                   {!this.state.isApp ? <div className="lhs-side-ad" role="img" aria-label="Advertisement unit" tabIndex={0}>
                    <div style={{ padding: "5px", textAlign: "center" }} >ADVERTISEMENT</div>
                    {/* <GPT
                        adUnitPath={gptAry['desktoplhs']['path']}
                        slotSize={gptAry['desktoplhs']['slot']}
                        renderWhenViewable={false}
                    /> */}
                    <DFPSlotsProvider
                        dfpNetworkId={gptAry['desktoplhs']['id']}
                        adUnit={gptAry['desktoplhs']['path']}
                        slotSize={gptAry['desktoplhs']['slot']}
                        renderWhenViewable={false}
                    ></DFPSlotsProvider>
                </div> : ''}
                {!this.state.isApp ? <div className="rhs-side-ad" role="img" aria-label="Advertisement unit" tabIndex={0}>
                    <div style={{ padding: "5px", textAlign: "center" }} >ADVERTISEMENT</div>
                    {/* <GPT
                        adUnitPath={gptAry['desktoprhs']['path']}
                        slotSize={gptAry['desktoprhs']['slot']}
                        renderWhenViewable={false}
                    /> */}
                     <DFPSlotsProvider
                        dfpNetworkId={gptAry['desktoprhs']['id']}
                        adUnit={gptAry['desktoprhs']['path']}
                        slotSize={gptAry['desktoprhs']['slot']}
                        renderWhenViewable={false}
                    ></DFPSlotsProvider>
                </div> : ''}
                  
                

            <main className="main-container colouring-page coloring-details">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                {!this.state.isApp ? <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/coloring-pages-printables/")} className="R11_9e">Colouring Page & Printables</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>{this.state.CatNameBreadcrm}</span>
                        {/* <span><a href={service.getRedirectUrl(`/coloring-pages-printables/${this.props.location.pathname.split("?")[0].split('/')[2]}/`)} className="R11_9e">{this.props.location.pathname.split("?")[0].split('/')[2].split("-").join(" ")}</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl(`/coloring-pages-printables/${this.props.location.pathname.split("?")[0].split('/')[2]}/${this.props.location.pathname.split("?")[0].split('/')[3]}/`)} className="R11_9e">{this.props.location.pathname.split("?")[0].split('/')[3].split("-").join(" ")}</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>{this.props.location.pathname.split("?")[0].split('/')[4].split("-").join(" ")}</span> */}
                    </div>
                    {/* <h1 className="B24_00 left">{this.state.seoData && this.state.seoData !="" && this.state.seoData[0].hedding != ""?this.state.seoData[0].hedding:''}</h1> */}

                    <h1 className="B24_00 left" id="skipToH1" role="heading" tabIndex="0">{this.state.CatNameBreadcrm}</h1>

                </div> :''}
                   {this.state.isApp ? <div className="app-title"> <h1 className="B24_00 left">{this.state.CatNameBreadcrm}</h1>
                </div>: ''}
                <div className="sub-container left">
                    <div className="data-container coloring-details left">
                        <div className="download-image">
                            {/* <a href={service.getRedirectUrl(`/coloring-pages-printables/${this.props.location.pathname.split("?")[0].split('/')[2]}/${this.props.location.pathname.split("?")[0].split('/')[3]}/`)} className="backshare-btn backbtn" data-icon-font="s"> */}
                            <div onClick={(e)=>this.goBack(e)} className="backshare-btn backbtn" data-icon-font="s" role="button" tabIndex="0" aria-label="Go Back" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                this.goBack(e);
                            }}}><span>Back</span>
                            </div>
                        
                            {this.state.isApp ?  <div data-icon-font="&#xe028;" className="backshare-btn share-btn" id={`share_${this.state.initialData.subCategory[0].categoryId}`} onClick={() => action.callback("Share", this.state.isApp, this.state.CatNameBreadcrm)}><span>Share</span>
                                {/* <ShareOptions cat={this.state.initialData.subCategory} eleRef={this} /> */}
                            </div> :  <div data-icon-font="&#xe028;" className="backshare-btn share-btn" id={`share_${this.state.initialData.subCategory[0].categoryId}`} onClick={action.shareOn.bind(this, this.state.initialData.subCategory[0].categoryId)} role="button" tabIndex="0" aria-label="Share" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                action.shareOn.bind(this, this.state.initialData.subCategory[0].categoryId)();
                            }}}><span>Share</span>
                                <ShareOptions cat={this.state.initialData.subCategory} eleRef={this} />
                            </div>}
                            <div className="share-overlay"></div>
                        </div>
                          {/* code for msite left ad */}
                         { !this.state.isApp ?  <div className="msite-lhs-side-ad" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                    <div style={{ padding: "5px", textAlign: "center" }} >ADVERTISEMENT</div>
                                    {/* <GPT
                                        adUnitPath={gptAry['msitelhs']['path']}
                                        slotSize={gptAry['msitelhs']['slot']}
                                        renderWhenViewable={false}
                                    /> */}
                        {/* <DFPSlotsProvider
                        dfpNetworkId={gptAry['msitelhs']['id']}
                        adUnit={gptAry['msitelhs']['path']}
                        slotSize={gptAry['msitelhs']['slot']}
                        renderWhenViewable={false}
                    ></DFPSlotsProvider> */}
                                    
                           </div> : ''}
                        <div className="img-slider-top">
                            <div className="image-slider-cnt">
                                {/* <div className="image-slider"> */}
                                    {this.state.initialData.subCategory && this.state.initialData.subCategory.map((subcat, index) =>
                                        <div key={index} className="img-slide" id={`cat_${subcat.categoryId}`}>
                                            {subcat.imgUrl ?
                                                <img src={subcat.imgUrl} onError={(e) => { e.target.src = '/media/default-placeholder.png'; }} alt={`${subcat.categoryName}`} title={`${subcat.categoryName}`} />
                                                :
                                                <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-placeholder.png'} alt={`${subcat.categoryName}`} title={`${subcat.categoryName}`} />
                                            }
                                            <span className="M24_61 slide-title">{subcat.categoryName}</span>
                                        </div>
                                    )}
                                {/* </div> */}
                                
                            </div>

                            {/* {this.state.initialData.otherCategories && this.state.initialData.otherCategories.length > 2 && 
                            <a data-icon-font="g" className="prv-img nxt-prv" href={service.getRedirectUrl(`/coloring-pages-printables/${this.props.location.pathname.split("?")[0].split('/')[2]}/${this.props.location.pathname.split("?")[0].split('/')[3]}/${service.replaceSymbols(this.state.initialData.otherCategories[this.state.initialData.otherCategories.length-1].categoryName)}/`)}></a>
                            }
                            {this.state.initialData.otherCategories && this.state.initialData.otherCategories.length > 1 && 
                            <a data-icon-font="h" className="nxt-img nxt-prv" href={service.getRedirectUrl(`/coloring-pages-printables/${this.props.location.pathname.split("?")[0].split('/')[2]}/${this.props.location.pathname.split("?")[0].split('/')[3]}/${service.replaceSymbols(this.state.initialData.otherCategories[0].categoryName)}/`)}></a>
                            } */}
                        </div>
                         {/* code for msite right ad */}
                        { !this.state.isApp ?  <div className="msite-rhs-side-ad" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                    <div style={{ padding: "5px", textAlign: "center" }} >ADVERTISEMENT</div>
                                    {/* <GPT
                                        adUnitPath={gptAry['msiterhs']['path']}
                                        slotSize={gptAry['msiterhs']['slot']}
                                        renderWhenViewable={false}
                                    /> */}
                                    {/* <DFPSlotsProvider
                        dfpNetworkId={gptAry['msiterhs']['id']}
                        adUnit={gptAry['msiterhs']['path']}
                        slotSize={gptAry['msiterhs']['slot']}
                        renderWhenViewable={false}
                    ></DFPSlotsProvider> */}
                            </div> : ''}
                        
                            <div className="image_copyright">
                            {this.state.isApp ?
                            <a href="javascript:void(0)" className="M13_9e"  onClick={() => action.callback("copyRight", this.state.isApp , '')} >Image Copyright Policy</a>
                            :
                            <a href="https://parenting.firstcry.com/content-image-usage-policy/" className="M13_9e" target="_blank">Image Copyright Policy</a>                            
                            }
                            </div>
                            
                        
                       
                        {this.state.isApp ? 
                        <div onClick={() => action.callback("Download", this.state.isApp , (this.state.initialData.subCategory[0].imgUrl )? this.state.initialData.subCategory[0].imgUrl:window.location.origin +'/media/default-placeholder.png')} >
                            <div className="download-btn" data-icon-font="^" >Download</div> 
                        </div>: 
                        <div className="download-btn" data-icon-font="^" onClick={() => service.forceDownload((this.state.initialData.subCategory[0].imgUrl)?this.state.initialData.subCategory[0].imgUrl:'/media/default-placeholder.png', this)} role="button" tabIndex="0" aria-label="Download Image" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            service.forceDownload((this.state.initialData.subCategory[0].imgUrl)?this.state.initialData.subCategory[0].imgUrl:'/media/default-placeholder.png', this);
                        }}}>Download</div>
                        }
                        {!this.state.isApp ? <div className="download-ads block">
                            <div className="desktop-ads-block" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                <div style={{ textAlign: "center", padding: "5px" }} >ADVERTISEMENT</div>
                                {/* <GPT
                                    adUnitPath={gptAry['desktop']['path']}
                                    slotSize={gptAry['desktop']['slot']}
                                    renderWhenViewable={false}
                                /> */}
                                <DFPSlotsProvider
                        dfpNetworkId={gptAry['desktop']['id']}
                        adUnit={gptAry['desktop']['path']}
                        slotSize={gptAry['desktop']['slot']}
                        renderWhenViewable={false}
                    ></DFPSlotsProvider>
                            </div>
                            <div className="msite-ads-block" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                <div style={{ textAlign: "center", padding: "5px" }} >ADVERTISEMENT</div>
                                {/* <GPT
                                    adUnitPath={gptAry['msite']['path']}
                                    slotSize={gptAry['msite']['slot']}
                                    renderWhenViewable={false}
                                /> */}
                                <DFPSlotsProvider
                        dfpNetworkId={gptAry['msite']['id']}
                        adUnit={gptAry['msite']['path']}
                        slotSize={gptAry['msite']['slot']}
                        renderWhenViewable={false}
                    ></DFPSlotsProvider>
                              </div>
                        </div>: '' }
                        

                        <div className="img-slider-btm">
                            <div className="other-img-slider">
                                <div className="other-slider">
                                    {this.state.initialData && this.state.initialData.otherCategories && this.state.initialData.otherCategories.map((subcat, index) =>
                                    <div key={index} className="otherimg-slide" onClick={() => action.gotoDetailsPage(service.replaceSymbols(this.props.location.pathname.split("?")[0].split('/')[2]),service.replaceSymbols(this.props.location.pathname.split("?")[0].split('/')[3]), service.replaceSymbols(subcat.categoryName),subcat.categoryId)} role="button" tabIndex="0" aria-label={`View details for ${subcat.categoryName}`} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        action.gotoDetailsPage(service.replaceSymbols(this.props.location.pathname.split("?")[0].split('/')[2]),service.replaceSymbols(this.props.location.pathname.split("?")[0].split('/')[3]), service.replaceSymbols(subcat.categoryName),subcat.categoryId);
                                    }}}>
                                        {subcat.imgUrl ?
                                            <img src={subcat.imgUrl} onError={(e) => { e.target.src = '/media/default-placeholder.png'; }} alt={`${subcat.categoryName}`} title={`${subcat.categoryName}`} className="dev_othr_imgs"/>
                                            :
                                            <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-placeholder.png'} alt={`${subcat.categoryName}`} title={`${subcat.categoryName}`} className="dev_othr_imgs"/>
                                        }                                       
                                        <span className="M14_42 slide-ttl">{subcat.categoryName}</span>
                                    </div>
                                    )}
                                </div>
                            </div>
                            <div data-icon-font="g" className="prv-img nxt-prv" onClick={(e) => action.prevSlide(e)}></div>
                            <div data-icon-font="h" className="nxt-img nxt-prv" onClick={(e) => action.nextSlide(e)}></div>
                        </div>
                    </div>
                </div>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"></script>
            </main>
            </div>
        )
    }
}

export default withContext(ColoringDetails);
